<template>
  <div class="login">
    <div class="login-bg register-bg"></div>
    <main class="container consent">
      <router-link to="login">
        <img src="~@/assets/images/logo-full-mono-light.png" alt />
      </router-link>
      <h1>Research Participant Consent</h1>
      <div class="page">
        <div class="consentContainer" v-if="showConsent">
          <Consent
            :consent.sync="consent"
            :recruitmentId="recruitmentId"
            :candidate.sync="candidate"
            class="consentText"
            v-on:saveConsentResponse="saveConsentResponse"
          ></Consent>
        </div>
        <div v-else-if="showConsentThanksResponse" class="consentContainer">
          <h2>Your response has been submitted</h2>
          <p v-html="consent.thanksResponse"></p>
          <!-- <p class='p-4'>
            <a href='https://microba.com' class='btn btn-primary btn-lg'>Learn more about Microba</a>
          </p> -->
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Consent from '@/components/Consent'
import btVueButton from 'bt-vue-button'
import {microbaFailure, microbaSuccess, microbaLoader} from '@/services/notificationServices'
import { CandidateModel } from '@/model/candidate'
import { ConsentModel } from '@/model/consent'

export default {
  name: 'researchConsent',
  components: { Consent, btVueButton },
  computed: {
    recruitmentId () {
      return Number(this.$route.params.recruitmentId)
    },
    showConsent () {
      return this.isvalidConsent && !this.thankUserPointReached
    },
    showConsentThanksResponse () {
      return this.isvalidConsent && this.thankUserPointReached
    },
    isvalidConsent () {
      return this.recruitmentId &&
      this.consent &&
      this.consent.id &&
      this.candidate &&
      this.candidate.id
    }
  },
  data () {
    return {
      thankUserPointReached: null,
      consent: null,
      candidate: null
    }
  },
  mounted () {
    this.consent = new ConsentModel({ id: this.$route.params.consentId })
    this.candidate = new CandidateModel({ id: this.$route.params.candidateId })
  },
  methods: {
    saveConsentResponse () {
      this.$store
        .dispatch(
          'putRecruitmentCandidateConsent',
          Object.assign(this.consent, this.candidate, {
            recruitmentId: this.recruitmentId,
            consentId: this.consent.id,
            candidateId: this.candidate.id
          })
        )
        .then(response => {
          microbaSuccess({text: `Thank you, your response has been submitted.`})
          microbaLoader.showLoader()
          setTimeout(() => {
            microbaLoader.hideLoader()
            if (!response.data.nextConsentId) {
              this.thankUserPointReached = true
            } else {
              this.consent = new ConsentModel({
                id: response.data.nextConsentId
              })
            }
          }, 1000)
        })
        .catch(error => {
          microbaFailure({
            text: `Failed to save response, please try again.`
          })
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.consent {
  .page {
    padding: 1.75rem 1.5rem 0rem 1.5rem;
    background: #ffffff;
    border-radius: 0.3rem;
    .consentContainer {
      min-height: 500px;
      font-size: 1rem;
      .consentText {
        font-size: 1rem;
        padding: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/application/research/ResearchConsent.vue